<template>
    <div
        ref="modalRoot"
        aria-hidden="true"
        class="modal fade"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Deactivate Account</h3>
                    <button
                        aria-label="Close"
                        class="close"
                        data-dismiss="modal"
                        type="button"
                    >
                        <span>&times;</span>
                    </button>
                </div>

                <div class="modal-body mx-auto text-center">
                    <h3 class="font-weight-normal">Are you sure you want to deactivate {{ name }}?</h3>
                    <p class="text-danger">To reactivate, please contact the technology team.</p>

                    <div class="row">
                        <div class="col-12 my-3 text-center">
                            <button
                                v-if="!isFetching"
                                class="btn btn-success btn-circle"
                                type="button"
                                @click="() => submitDeactivateRequest()"
                            >
                                Yes
                            </button>
                            <LoadingSpinner
                                v-else
                                size-classes="w-10 h-10 mx-auto"
                                :space="false"
                            />
                        </div>

                        <div class="col-12">
                            <button
                                class="btn btn-primary btn-circle cancel"
                                data-dismiss="modal"
                                type="button"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import LoadingSpinner from '@/components/Icons/LoadingSpinner.vue';
import { useBootstrapModal } from '@/shared/composables/use-bootstrap-modal';
import { toastOnUseFetchResponse } from '@/shared/utils/toastr';
import { useFetch } from '@vueuse/core';
import { ref } from 'vue';
import type { AccountApiResponse } from './Account.types';

const props = defineProps<Pick<AccountApiResponse['account'], 'id' | 'name'>>();

const modalRoot = ref<HTMLElement>();
const showModal = defineModel<boolean>({ default: false });
const emit = defineEmits<{ deactivated: [id: AccountApiResponse['account']['id']] }>();

useBootstrapModal(modalRoot, showModal);

const {
    execute: submitDeactivateRequest,
    onFetchResponse: onDeactivateSuccess,
    isFetching,
} = useFetch(`/api/accounts/${props.id}/deactivate`, {
    immediate: false,
    afterFetch: toastOnUseFetchResponse,
})
    .patch()
    .json();

onDeactivateSuccess(() => {
    showModal.value = false;
    emit('deactivated', props.id);
});
</script>

<style lang="scss" scoped>
.modal-body {
    width: 60%;
}

.btn {
    width: 96px;
}
</style>
